import {
  getByIdMediaSelector,
  MEDIA_MODEL_KEY,
  MEDIA_MODEL_TYPE
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { logUtil } from 'packages/src'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { Image } from 'components/Image'
import { BRAND_IMAGE } from 'constants/brand.js'

/**
 * @param props
 * @param props.media
 * @param props.useThumbnail
 * @param props.useDefaultImage
 * @param props.fallbackImage
 * @param props.error
 * @param props.shouldDirectlyLoadTheSrcIfFallback
 * @returns {*}
 */
function getUrlDataMediaImageUtil (props) {
  const {
    media,
    useThumbnail,
    useDefaultImage,
    error,
    fallbackImage
  } = props

  let url
  if (useThumbnail) {
    url = getValueReduxUtil(media, MEDIA_MODEL_KEY.THUMBNAIL)
  }

  if (
    !url &&
    getValueReduxUtil(media, MEDIA_MODEL_KEY.TYPE) !== MEDIA_MODEL_TYPE.VIDEO
  ) {
    url = getValueReduxUtil(media, MEDIA_MODEL_KEY.URL)
  }

  let shouldDirectlyLoadTheSrc
  if (
    !url &&
    fallbackImage &&
    !error
  ) {
    url = fallbackImage
    shouldDirectlyLoadTheSrc = true
  } else if (
    !url &&
    useDefaultImage &&
    !fallbackImage
  ) {
    url = BRAND_IMAGE
  } else if (error) {
    url = BRAND_IMAGE
  }

  return {
    url,
    shouldDirectlyLoadTheSrc
  }
}

/**
 * @param props
 * @param props.id
 * @param props.children
 * @param props.useThumbnail
 * @param props.useDefaultImage
 * @param props.fallbackImage
 * @param props.shouldDirectlyLoadTheSrcIfFallback
 * @param props.imgStyle
 * @returns {React.JSX.Element|*}
 * @constructor
 */
export default function MediaImage (props) {
  const {
    id,
    children,
    useThumbnail,
    useDefaultImage = true,
    fallbackImage,
    ...rest
  } = props
  const media = useSelector(getByIdMediaSelector(id))
  const [error, setError] = React.useState(false)
  const {
    url,
    shouldDirectlyLoadTheSrc
  } = getUrlDataMediaImageUtil({
    useThumbnail,
    useDefaultImage,
    media,
    error,
    fallbackImage
  })

  const handleError = () => {
    setError(true)
  }
  const debugProps = {
    media,
    id,
    url,
    props,
    error,
    useDefaultImage,
    shouldDirectlyLoadTheSrc
  }

  logUtil('MediaImage').debug('[start] debugProps=', debugProps)

  if (children) {
    return children({
      source: url
    })
  }

  return (
    <Image
      src={url}
      onError={handleError}
      shouldDirectlyLoadTheSrc={shouldDirectlyLoadTheSrc}
      {...rest}
    />
  )
}
